export default {
    setSessionId(sessionId) {
        localStorage.setItem("registration", JSON.stringify({
            time: new Date().valueOf(),
            sessionId: sessionId
        }))
    },

    waitingForConformation() {
        if (localStorage.getItem("registration") == null) {
            return false
        }

        let registration = JSON.parse(localStorage.getItem("registration"))
        // console.log(registration)
        if (new Date().valueOf() < (registration.time + (1000 * 60 * 30))){
            return true
        }
        this.clearData()
        return false
    },

    getSessionId() {
        return JSON.parse(localStorage.getItem("registration")).sessionId
    },

    clearData() {
        localStorage.removeItem("registration")
    },
    
    setReturnToUrl(url) {
        localStorage.setItem("registrationReturnToURL", url)
    },

    getReturnToUrl() {
        let url = localStorage.getItem("registrationReturnToURL")
        if (url) {
            localStorage.removeItem("registrationReturnToURL")
            return url
        }
        return null
    }
}